import { unreachableCaseError } from "@edgetier/utilities";
import { AgentStateType } from "@edgetier/watchtower-types";
import { IAgentStateLookup } from "./live-agents-table-state-column.types";

/**
 * Create the state class name using the agent state id
 * @param currentAgentStateId
 * @param agentStates
 * @returns Class name for agent state
 */
export const createStateClassName = (currentAgentStateId: string | null, agentStates: IAgentStateLookup) => {
    if (typeof currentAgentStateId === "string") {
        const agentState = agentStates[currentAgentStateId];

        if (typeof agentState === "undefined") {
            return "";
        }

        const parentClassName = "live-agents-table-state-column";
        switch (agentState) {
            case AgentStateType.Available:
                return `${parentClassName}--${AgentStateType.Available.toLocaleLowerCase()}`;
            case AgentStateType.Unavailable:
                return `${parentClassName}--${AgentStateType.Unavailable.toLocaleLowerCase()}`;
            case AgentStateType.Offline:
                return `${parentClassName}--${AgentStateType.Offline.toLocaleLowerCase()}`;
            default:
                unreachableCaseError(agentState);
                return "";
        }
    }

    return "";
};
